import { createStore, applyMiddleware } from 'redux';
import { routerMiddleware } from 'connected-react-router';
import createSagaMiddleware from 'redux-saga';
import formActionSaga from 'redux-form-saga';
import { createLogger } from 'redux-logger';
import createReducer from './reducers';
import rootSaga from "./sagas";
import notificationSaga from '../notif-msg-modules/src/modules/notification/reducer/rootSaga';

import history from '../utils/history';
import { loadUser } from "redux-oidc";
import userManager from "../utils/userManager";


const loggerMiddleware = createLogger()

const initialState = {};

function configureStore(initialState = {}, history) {
  // let composeEnhancers = compose;
  const reduxSagaMonitorOptions = {};

  // if (process.env.NODE_ENV !== 'production' && typeof window === 'object') {
  //   if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
  //     composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});
  // }

  const bindMiddleware = middleware => {
    if (process.env.NODE_ENV !== 'production') {
      middleware.push(loggerMiddleware)
    }
    return applyMiddleware(...middleware)
  }

  const sagaMiddleware = createSagaMiddleware(reduxSagaMonitorOptions);

  const store = createStore(
    createReducer(history),
    initialState,
    bindMiddleware([sagaMiddleware, routerMiddleware(history)])
  )
    
  loadUser(store, userManager);
  // Extensions
  sagaMiddleware.run(rootSaga);
  sagaMiddleware.run(formActionSaga);
  sagaMiddleware.run(notificationSaga);
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry


  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(history, store.injectedReducers));
    });
  }

  return store;
}

export default configureStore(initialState, history);
